let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("cqT0F"), load("esOEn")]).then(() => parcelRequire('cJjT8'));